import React, { Component } from 'react';
// import videojs from 'video.js'
import VideoPlayer from './VideoPlayer';
import { Button } from 'reactstrap';

class WatchVideo extends Component {

  render() {
    let vidType = 'video/mp4';
    if(this.props.videoSrc.indexOf('webm') > -1) {
      vidType = 'video/webm';
    }
    const videoJsOptions = {
      autoplay: false,
      controls: true,
      sources: [{
        src: this.props.videoSrc,
        type: vidType
      }]
    };

    return (
      <div className="Step WatchVideo">
        <h1>{this.props.headline}</h1>
        {this.props.description && <div dangerouslySetInnerHTML={this.props.createMarkup(this.props.description)} />}
        <div className="fit-vid">
          <VideoPlayer { ...videoJsOptions } />
        </div>
        <div className="buttons">
          {this.props.buttonNext &&
            (<Button color="primary" className="float-right" onClick={this.props.advanceStep}>Next</Button>)
          }
        </div>
      </div>
    );
  }
}

export default WatchVideo;



// WEBPACK FOOTER //
// ./src/WatchVideo.js